import { requestJson } from './requestJson';

export async function postClaimTestByKey(dashboardKey: string): Promise<{
  test_id: string;
  title: string | null;
}> {
  return await requestJson('/api/my/claim', {
    method: 'POST',
    body: JSON.stringify({ dashboard_key: dashboardKey })
  });
}
